module.exports = __webpack_public_path__ + "static/handMobile-4927d3c58051a4e623cb69d6d5b8288a.png";